import { checkout } from '@/api/user'
export default {
  state: {
    items: [],
    address: null,
  },

  mutations: {
    ADD_TO_CART: (state, product) => {
     
      state.items.push({product_id:product.id ,product :product,quantity:1})
    },

    UPDATE_CART_ITEM: (state, newItem) => {
      state.items = state.items.map(item => {
        if (item.product_id === newItem.product_id) {
          item.quantity = newItem.quantity
        }
        return item
      })
    },

    REMOVE_CART_ITEM: (state, product_id) => {
      state.items = state.items.filter(item => item.product_id !== product_id)
    },

    SET_CART_ADDRESS: (state, address) => {
      state.address = address
    },
    CLEAR_CART: (state) => {
      state.items = []
    },
  },

  actions: {
    addToCart({ commit }, product) {
      commit('ADD_TO_CART', product)
    },

    updateCartItem({ commit }, cartItem) {
      if (cartItem.quantity < 1) {
        commit('REMOVE_CART_ITEM', cartItem.product_id)
      }
      else {
        commit('UPDATE_CART_ITEM', cartItem)

      }
    },

    removeFromCart({ commit }, product_id) {
      commit('REMOVE_CART_ITEM', product_id)
    },

    clearCart({ commit }) {
      commit('CLEAR_CART')
    },

    setCartAddress({ commit }, address) {
      commit('SET_CART_ADDRESS', address)
    },


    checkout({ commit, state }) {
      return new Promise((resolve, reject) => {
        const items = state.items.map(item => {
          return {
            product_id: item.product_id,
            quantity: item.quantity
          }
        })
        checkout(items, state.address.id)
          .then(({ data }) => {
            state.items = []
            state.address = null
            resolve(data)
          })
          .catch(e => reject(e))
      })
    }
  }
}
